import type { MoneyMapsForMembershipAdmin } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export const getMoneyMapsForMembershipQueryKey = ({
    membershipId,
}: {
    membershipId?: string | null;
}): string => `getMoneyMapsForMembershipSplitContext/${membershipId ?? ''}`;

export const useGetMoneyMapsForMembership = requestBuilder.query<
    MoneyMapsForMembershipAdmin,
    { membershipId: string }
>({
    endpoint: ({ membershipId }) =>
        `/api/admin/money-map/membership/${membershipId}/split-context`,
    queryKey: getMoneyMapsForMembershipQueryKey,
});
